export default __webpack_public_path__ + "static/media/feedback_good_02.d671c02c.png";